import type { NavbarGroupProps } from '@vlabs/uikit';
import { NavbarGroup as UIKitNavbarGroup } from '@vlabs/uikit';

import { useNavbarContext } from '../useNavbarContext';

function NavbarGroup(props: Omit<NavbarGroupProps, 'format'>): React.JSX.Element {
  const ctx = useNavbarContext();

  return (
    <UIKitNavbarGroup
      {...props}
      format={ctx.type}
    />
  );
}

export { NavbarGroup };
